<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <img class="Form__menmber_img" src="assets/img/paid_member.png" alt="毎月300以上クラスを開催">
          <a href="/" class="Btn__blue Btn__blue--md Form__btn--mt_md Form__btn--mt_sp_sm">有料会員になる</a>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'ChangeMemberShip'
}
</script>
